import React, { ReactElement } from 'react';
import { Column } from 'react-data-grid';
import { useLocation } from 'react-router-dom';
import { getColConfig, saveColConfig, clearColConfig } from './utils';
import { DropdownMenu, DropdownToggle, Popover, UncontrolledDropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears, faLocationPin, faUndo } from '@fortawesome/free-solid-svg-icons';

interface Props {
  originColumns: Column<any, any>[];
  columns: Column<any, any>[];
  onColumnsChange: (c: Column<any, any>[]) => void;
  onColumnsDisplayChange: (hiddenCols: string[]) => void;
  columnsKeyConfig?: string;
}
export default function ColumnsSetting({ originColumns, columns, onColumnsDisplayChange, onColumnsChange, columnsKeyConfig }: Props): ReactElement {
  const { pathname } = useLocation();
  const [hiddenCols, setHiddenCols] = React.useState<string[]>([]);

  React.useEffect(() => {
    let cols = getColConfig(pathname, columnsKeyConfig);
    if (cols.length) {
      onColumnsDisplayChange(cols);
    }
    setHiddenCols(cols);
  }, [pathname, columnsKeyConfig]);

  // function

  const onDisplayChange = (checked: boolean, key: string) => {
    let _hiddenCols: Array<string> = [];
    if (checked) {
      _hiddenCols = hiddenCols.filter(x => x !== key);
    } else {
      _hiddenCols = Array.from(new Set([...hiddenCols, key]));
    }
    setHiddenCols(_hiddenCols);
    saveColConfig(pathname, _hiddenCols, columnsKeyConfig);
    onColumnsDisplayChange(_hiddenCols);
  };

  const onPinColChange = (checked: boolean, key: string) => {
    let _cols: any[] = [...columns.map(c => ({ ...c }))];
    for (var i = 0; i < _cols.length; i++) {
      if (_cols[i].key === key) {
        _cols[i].frozen = checked;
        break;
      }
    }
    onColumnsChange(_cols);
  };
  const reset = () => {
    clearColConfig(pathname, columnsKeyConfig);
    setHiddenCols([]);
    onColumnsChange([...originColumns]);
    onColumnsDisplayChange([]);
  };

  return (
    <div className="d-flex  x-gap-10">
      <UncontrolledDropdown tag="div" direction="up">
        <DropdownToggle tag="div" className="ml-5 text-light-1 ">
          <FontAwesomeIcon icon={faGears} />
        </DropdownToggle>
        <DropdownMenu tag="div" className="search-box-transition  shadow-2">
          <div className="w-250px">
            <div className="fw-500 bg-blue-1 px-20 py-10 text-white">Display columns Config</div>
            <div className="px-20 py-10">
              {originColumns
                ?.filter(x => x.name)
                .map(col => {
                  return (
                    <div className="form-check form-switch" key={col.key}>
                      <input
                        checked={!hiddenCols.some(c => c === col.key)}
                        onChange={event => onDisplayChange(event.target.checked, col.key)}
                        type="checkbox"
                        role="switch"
                        className="form-check-input"
                        id={`col-config-${col.key}`}
                      />
                      <label className="form-check-label" htmlFor={`col-config-${col.key}`}>
                        {col.name}
                      </label>
                    </div>
                  );
                })}
            </div>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
      <UncontrolledDropdown tag="div" direction="up">
        <DropdownToggle tag="div" className="ml-5 text-light-1">
          <FontAwesomeIcon icon={faLocationPin} />
        </DropdownToggle>
        <DropdownMenu tag="div" className="search-box-transition  shadow-2">
          <div className="w-250px">
            <div className="fw-500 bg-blue-1 px-20 py-10 text-white">Pin columns config</div>
            <div className="px-20 py-10">
              {columns
                ?.filter(x => x.name)
                .map(col => {
                  return (
                    <div className="form-check form-switch" key={col.key}>
                      <input
                        checked={!!col.frozen}
                        onChange={event => onPinColChange(event.target.checked, col.key)}
                        type="checkbox"
                        role="switch"
                        className="form-check-input"
                        id={`col-pin-${col.key}`}
                      />
                      <label className="form-check-label" htmlFor={`col-pin-${col.key}`}>
                        {col.name}
                      </label>
                    </div>
                  );
                })}
            </div>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
      <button className="ml-5 text-light-1" onClick={reset}>
        <FontAwesomeIcon icon={faUndo} />
      </button>
    </div>
  );
}
